var map = {
	"./Heroes Legend.ttf": 917,
	"./PixelifySans-Regular.ttf": 918,
	"./PixelifySans-Regular.woff2": 919,
	"./ProximaNova-Black.otf": 920,
	"./ProximaNova-Black.woff2": 921,
	"./ProximaNova-Bold.otf": 922,
	"./ProximaNova-Bold.woff2": 923,
	"./ProximaNova-Extrabold.otf": 924,
	"./ProximaNova-Extrabold.woff2": 925,
	"./ProximaNova-Light.otf": 926,
	"./ProximaNova-Light.woff2": 927,
	"./ProximaNova-Regular.otf": 928,
	"./ProximaNova-Regular.woff2": 929,
	"./ProximaNova-Semibold.otf": 930,
	"./ProximaNova-Semibold.woff2": 931,
	"./heroes_legend-webfont.woff": 932,
	"./heroes_legend-webfont.woff2": 933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 916;